import React, { useState } from "react";

function AddressSection({
  city,
  setCity,
  postcode,
  setPostcode,
  country,
  setCountry,
  address,
  setAddress,
}) {
  const [editMode, setEditMode] = useState(false);

  const handleAddressChange = (event) => setAddress(event.target.value);
  const handleCityChange = (event) => setCity(event.target.value);
  const handlePostcodeChange = (event) => setPostcode(event.target.value);
  const handleCountryChange = (event) => setCountry(event.target.value);

  const handleSave = () => {
    // Save address to database
    // ...
    //console.log("Address saved:", address, city, postcode, country);

    setEditMode(false);
  };

  const handleCancel = () => {
    setEditMode(false);
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  return (
    <div className="my-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Address</h2>

      <div>
        {address === "" ? (
          <p className="text-gray-500 text-sm">Address is empty!</p>
        ) : (
          <p className="text-gray-500 text-sm">{address}</p>
        )}
        {city === "" ? (
          <p className="text-gray-500 text-sm">city is empty!</p>
        ) : (
          <p className="text-gray-500 text-sm">{city}</p>
        )}
        {postcode === "" ? (
          <p className="text-gray-500 text-sm">postcode is empty!</p>
        ) : (
          <p className="text-gray-500 text-sm">{postcode}</p>
        )}
        {country === "" ? (
          <p className="text-gray-500 text-sm">country is empty!</p>
        ) : (
          <p className="text-gray-500 text-sm">{country}</p>
        )}
      </div>

      {editMode && (
        <div className="mt-2">
          <input
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            type="text"
            placeholder="Your street name and house/apartment number"
            value={address}
            onChange={handleAddressChange}
          />
          <input
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            type="text"
            placeholder="Town/city"
            value={city}
            onChange={handleCityChange}
          />
          <input
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            type="text"
            placeholder="Postcode"
            value={postcode}
            onChange={handlePostcodeChange}
          />
          <select
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            value={country}
            onChange={handleCountryChange}
          >
            <option value="">Select the country/region you live in</option>
            <option value="USA">USA</option>
            <option value="Canada">Canada</option>
            <option value="UK">UK</option>
            <option value="Australia">Australia</option>
            <option value="Germany">Germany</option>
            <option value="France">France</option>
          </select>
          <div className="flex justify-end mt-4">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 mr-2 rounded"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      )}
      <button
        className="text-blue-500 hover:text-blue-700 text-sm"
        onClick={handleEdit}
      >
        Edit
      </button>
    </div>
  );
}

export default AddressSection;
